import {useEffect, RefObject} from 'react'
import * as bodyScrollLock from 'body-scroll-lock'

// @Todo change to BODY_SCROLL_LOCK_IGNORE_SELECTOR
export const BODY_SCROLL_LOCK_IGNORE = '[data-body-scroll-lock-ignore]'

interface Props {
  // TODO: Disabled for enforcing lint, fix if possible
  // eslint-disable-next-line no-undef
  ref: RefObject<HTMLDivElement>
  isEnabled?: boolean
  allowTouchMove?: boolean // See docs: https://www.npmjs.com/package/body-scroll-lock#allowtouchmove
}

const useBodyScrollLock = ({
  ref,
  isEnabled = true,
  allowTouchMove = false
}: Props) => {
  useEffect(() => {
    if (!isEnabled) return

    const element = ref.current

    const disableScrollOptions = allowTouchMove
      ? {
          allowTouchMove: (el: HTMLElement) =>
            Boolean(el.closest(BODY_SCROLL_LOCK_IGNORE))
        }
      : undefined

    const timeout = setTimeout(() => {
      bodyScrollLock.disableBodyScroll(element, {
        ...disableScrollOptions,
        reserveScrollBarGap: true
      })
    }, 0)

    return () => {
      if (timeout) window.clearTimeout(timeout)

      bodyScrollLock.enableBodyScroll(element)
    }
  }, [ref, isEnabled, allowTouchMove])
}

export default useBodyScrollLock
